// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__1eYIu","rotation":"preloader_rotation__1VvCY","anim_rotation":"preloader_anim_rotation__10te_"};